import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { ReactNode } from 'react';

type SectionHeadingProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  /** `split` puts the description on the right, `stacked` keeps it under the title. */
  layout?: 'split' | 'stacked';
  tone?: 'light' | 'dark';
};

export function SectionHeading({
  title,
  description,
  action,
  layout = 'stacked',
  tone = 'light',
}: SectionHeadingProps) {
  const heading = (
    <h2 className="m-0 mb-1.5 text-[clamp(1.7rem,3vw,2.5rem)] font-extrabold leading-[1.1] tracking-[-0.02em]">
      {title}
    </h2>
  );
  const text = description ? (
    <p className={cn('m-0 text-[1.02rem]', tone === 'dark' ? 'text-[#9aa6b1]' : 'text-[#5f6b76]')}>
      {description}
    </p>
  ) : null;

  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-x-8 gap-y-3">
      {layout === 'split' ? (
        <>
          {heading}
          {text}
        </>
      ) : (
        <div>
          {heading}
          {text}
        </div>
      )}
      {action}
    </div>
  );
}
